import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import { HashLoader } from "react-spinners";
import { useState, useEffect } from "react";

import { dateForHumans } from "../../utils/dateForHumans";
import timeAgo from "../../utils/timeAgo";
import { ICONS } from "../../utils/icons";
import { COLORS } from "../../utils/colors";
import { getTicketTransactions } from "../../api/ticketTransactions";
import { getCustomer } from "../../api/customers";

const fields = [
  {
    label: "Membership ID",
    value: "_id",
  },
  {
    label: "Type",
    value: "type",
  },
  {
    label: "Category Name",
    value: "category_name",
  },
  {
    label: "Created at",
    value: "createdAt",
  },
];

export const MembershipDetailsDrawer = ({
  open,
  setOpen,
  ticket,
  handleSnackbar,
  userData,
}) => {
  const [transactions, setTransactions] = useState([]);
  const [senders, setSenders] = useState([]);
  const [receivers, setReceivers] = useState([]);
  const [loading, setLoading] = useState({
    main: false,
    sender: false,
    receiver: false,
  });

  useEffect(async () => {
    if (ticket) {
      try {
        setLoading({ ...loading, main: true });

        const { data, error } = await getTicketTransactions(
          ticket.transactions,
          userData.operators[0].api_key
        );

        if (data) {
          setTransactions(data);
          setLoading({ ...loading, main: false });

          data.forEach(async (item, index) => {
            if (item.sender) {
              const sender = await fetchCustomer(item.sender, "sender");

              setSenders((prev) => [...prev, { email: sender?.email, index }]);
            } else {
              setSenders((prev) => [...prev, { email: "-", index }]);
            }

            if (item.receiver) {
              const receiver = await fetchCustomer(item.receiver, "receiver");

              setReceivers((prev) => [
                ...prev,
                { email: receiver?.email, index },
              ]);
            } else {
              setReceivers((prev) => [...prev, { email: "-", index }]);
            }
          });
        }

        if (error) {
          console.log(error);
          handleSnackbar("Error getting ticket transactions", "error");
          setLoading({ ...loading, main: false });
        }
      } catch (error) {
        console.log(error);
        handleSnackbar("Error getting ticket transactions", "error");
        setLoading({ ...loading, main: false });
      }
    }
  }, [ticket]);

  const fetchCustomer = async (id, role) => {
    try {
      role === "sender" && setLoading({ ...loading, sender: true });
      role === "receiver" && setLoading({ ...loading, receiver: true });

      const { data, error } = await getCustomer({
        customerID: id,
        apiKey: userData.operators[0].api_key,
      });

      if (data) {
        if (role === "sender") setLoading({ ...loading, sender: false });

        if (role === "receiver") setLoading({ ...loading, receiver: false });

        return data;
      }

      if (error) {
        console.log(error);
        handleSnackbar(
          "Error getting ticket transactions sender/receiver",
          "error"
        );
        setLoading({ ...loading, sender: false });
      }
    } catch (error) {
      console.log(error);
      handleSnackbar(
        "Error getting ticket transactions sender/receiver",
        "error"
      );
      setLoading({ ...loading, sender: false });
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const validityUnit = (unit, period) => {
    const unitMap = {
      d: "day",
      w: "week",
      m: "month",
      y: "year",
    };

    const pluralUnit = unitMap[unit] || unit;
    const pluralized = period === 1 ? pluralUnit : pluralUnit + "s";

    return pluralized;
  };

  const list = () => (
    <Box sx={{ width: 850, display: "flex", padding: 2 }} role="presentation">
      <div style={{ padding: 30 }}>
        <h2 style={{ margin: "0" }}>Membeership Data</h2>
        <p style={{ margin: "0 0 20px" }}>
          Analyze in detail the membership data
        </p>
        {loading.main ? (
          <HashLoader color={COLORS.black} size={20} />
        ) : (
          <div
            style={{
              border: `1px solid ${COLORS.lightGrey}`,
              padding: 30,
              borderRadius: 6,
              width: "740px",
              wordBreak: "break-all",
            }}
          >
            {fields.map((field) => {
              return (
                <div
                  key={field.value}
                  className="container-column"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: "-webkit-fill-available",
                    marginBottom: "20px",
                    borderBottom: "1px solid #e0e0e0",
                  }}
                >
                  <p
                    id="subheader"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      marginBottom: "3px",
                    }}
                  >
                    {field.label}
                  </p>
                  {field.value === "createdAt" && (
                    <p id="subheaderBlack">
                      {dateForHumans(ticket[field.value])}
                    </p>
                  )}
                  {field.value !== "createdAt" && (
                    <p id="subheaderBlack" style={{ marginBottom: "5px" }}>
                      {ticket[field.value]}
                    </p>
                  )}
                </div>
              );
            })}
            <div
              className="container-column"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "-webkit-fill-available",
                marginBottom: "20px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <p
                id="subheader"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  marginBottom: "3px",
                }}
              >
                Customer
              </p>
              <p id="subheaderBlack" style={{ marginBottom: "5px" }}>
                {ticket.customer.email}
              </p>
            </div>
            <div
              className="container-column"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "-webkit-fill-available",
                marginBottom: "20px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <p
                id="subheader"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  marginBottom: "3px",
                }}
              >
                Listing Price
              </p>
              <p id="subheaderBlack" style={{ marginBottom: "5px" }}>
                {ticket.original_price?.amount}{" "}
                {ticket.original_price?.currency}
              </p>
            </div>
            <div
              className="container-column"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "-webkit-fill-available",
                marginBottom: "20px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <p
                id="subheader"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  marginBottom: "3px",
                }}
              >
                Validity
              </p>
              <p id="subheaderBlack" style={{ marginBottom: "5px" }}>
                {ticket.membership_details?.validity}{" "}
                {validityUnit(
                  ticket.membership_details?.validity_unit,
                  ticket.membership_details?.validity
                )}
              </p>
            </div>
            {ticket.membership_details?.number && (
              <div
                className="container-column"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "-webkit-fill-available",
                  marginBottom: "20px",
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                <p
                  id="subheader"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    marginBottom: "3px",
                  }}
                >
                  Membership Number
                </p>
                <p id="subheaderBlack" style={{ marginBottom: "5px" }}>
                  {ticket.membership_details?.number}
                </p>
              </div>
            )}
            {ticket.smart_contract_address && (
              <div
                className="container-column"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "-webkit-fill-available",
                  marginBottom: "20px",
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                <p
                  id="subheader"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    marginBottom: "3px",
                  }}
                >
                  Smart Contract
                </p>
                <p id="subheaderBlack" style={{ marginBottom: "5px" }}>
                  {ticket.smart_contract_address}
                </p>
              </div>
            )}
            {(ticket.membership_details?.transferable === false ||
              ticket.membership_details?.transferable === true) && (
              <div
                className="container-column"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "-webkit-fill-available",
                  marginBottom: "20px",
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                <p
                  id="subheader"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    marginBottom: "3px",
                  }}
                >
                  Transferable
                </p>
                <p id="subheaderBlack" style={{ marginBottom: "5px" }}>
                  {ticket.membership_details?.transferable ? "Yes" : "No"}
                </p>
              </div>
            )}
            <div
              className="container-column"
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "-webkit-fill-available",
                marginBottom: "20px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <p
                id="subheader"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  marginBottom: "5px",
                }}
              >
                Transactions
              </p>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontFamily: "AuthenticSans90" }}>
                      Date
                    </TableCell>
                    <TableCell sx={{ fontFamily: "AuthenticSans90" }}>
                      Type
                    </TableCell>
                    <TableCell sx={{ fontFamily: "AuthenticSans90" }}>
                      Sender
                    </TableCell>
                    <TableCell sx={{ fontFamily: "AuthenticSans90" }}>
                      Receiver
                    </TableCell>
                    <TableCell sx={{ fontFamily: "AuthenticSans90" }}>
                      Price
                    </TableCell>
                    <TableCell sx={{ fontFamily: "AuthenticSans90" }}>
                      Status
                    </TableCell>
                    {ticket.smart_contract_address && (
                      <TableCell sx={{ fontFamily: "AuthenticSans90" }}>
                        Tx
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {transactions?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell sx={{ fontFamily: "AuthenticSans90" }}>
                          {dateForHumans(item.createdAt)}
                        </TableCell>
                        <TableCell sx={{ fontFamily: "AuthenticSans90" }}>
                          {item.type}
                        </TableCell>
                        <TableCell sx={{ fontFamily: "AuthenticSans90" }}>
                          {loading.sender ? (
                            <HashLoader color={COLORS.black} size={15} />
                          ) : (
                            senders[index] &&
                            senders.find((obj) => obj.index === index)?.email
                          )}
                        </TableCell>
                        <TableCell sx={{ fontFamily: "AuthenticSans90" }}>
                          {loading.receiver ? (
                            <HashLoader color={COLORS.black} size={15} />
                          ) : (
                            receivers[index] &&
                            receivers.find((obj) => obj.index === index)?.email
                          )}
                        </TableCell>
                        <TableCell sx={{ fontFamily: "AuthenticSans90" }}>
                          {item.price ? `${item.price} ${item.currency}` : "-"}
                        </TableCell>
                        <TableCell sx={{ fontFamily: "AuthenticSans90" }}>
                          {item.status}
                        </TableCell>
                        {ticket.smart_contract_address && (
                          <TableCell
                            sx={{
                              fontFamily: "AuthenticSans90",
                              fontWeight: "bold",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              item.tx_hash &&
                              window.open(
                                `${process.env.REACT_APP_POLYGONSCAN}/tx/${item.tx_hash}`
                              )
                            }
                          >
                            {item.tx_hash ? ICONS.external20 : "-"}
                          </TableCell>
                        )}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
            {ticket.history.general.length !== 0 && (
              <div
                className="container-column"
                style={{
                  display: "flex",
                  // flexDirection: "row",
                  justifyContent: "space-between",
                  width: "-webkit-fill-available",
                  marginBottom: "20px",
                }}
              >
                <p
                  id="subheader"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    marginBottom: "3px",
                  }}
                >
                  History
                </p>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontFamily: "AuthenticSans90" }}>
                        When
                      </TableCell>
                      <TableCell sx={{ fontFamily: "AuthenticSans90" }}>
                        Date
                      </TableCell>
                      <TableCell sx={{ fontFamily: "AuthenticSans90" }}>
                        Message
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {ticket.history.general?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell
                            sx={{
                              fontFamily: "AuthenticSans90",
                              fontWeight: "bold",
                            }}
                          >
                            {timeAgo(item.date)}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontFamily: "AuthenticSans90",
                              fontWeight: "bold",
                            }}
                          >
                            {dateForHumans(item.date)}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontFamily: "AuthenticSans90",
                              fontWeight: "bold",
                            }}
                          >
                            {item.message}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </div>
            )}
          </div>
        )}
      </div>
    </Box>
  );

  return (
    <Drawer anchor={"right"} open={open} onClose={() => handleClose()}>
      {list("right")}
    </Drawer>
  );
};
